import React from 'react';
import PropTypes from 'prop-types';
import ProductRelatedTable from './ProductRelatedTable';
import { connect } from 'react-redux';
import { fetchProductRelated } from 'store/actions/products/related/fetchProductRelated';

class ProductRelated extends React.Component {
    componentDidMount() {
        const { fetchRelated } = this.props;

        fetchRelated();
    }

    render() {
        const {
            productId,
        } = this.props;

        return <ProductRelatedTable
            productId={ productId }
            resource='productRelated'
        />;
    }
}

ProductRelated.propTypes = {
    productId: PropTypes.string.isRequired,
    fetchRelated: PropTypes.func.isRequired,
};

const mapsDispatchToProps = (dispatch, props) => {
    return {
        fetchRelated: () => {
            const { productId } = props;

            return dispatch(fetchProductRelated({
                productId: productId,
            }));
        },
    };
};

export default connect(
    null,
    mapsDispatchToProps,
)(ProductRelated);



// WEBPACK FOOTER //
// ./src/pages/products/productRelated/ProductRelated.js